
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/[...urlSlug]",
      function () {
        return require("private-next-pages/video/[...urlSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video/[...urlSlug]"])
      });
    }
  